import React from 'react';
import Text from "@amzn/meridian/text";
import {CurrencySymbol} from './constants'

/**
 * This component will render currency
 * 1. variance : Color coding for short/excess amount
 * 2. currency Symbol
 * 3. visibility upto two decimal place ( for paise )
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const Currency = (props) => {
    let {amount, isVariance} = props;
    let colorClass = "";
    let value;
    let symbol = CurrencySymbol[props.amount.unit];

    if (!Number.isFinite(amount.value)) {
        value = 0;
    } else {
        value = Number(amount.value.toFixed(2));
    }

    if (Boolean(isVariance)) {
        if (value > 0) {
            colorClass = "currency-excess";
        } else if (value < 0) {
            colorClass = "currency-short";
        }
        value = Math.abs(value);
    }
    return <Text className={colorClass}>{symbol} {value}</Text>;
}

export default Currency;


// WEBPACK FOOTER //
// ./src/component/common/currency.js